module.exports = __webpack_public_path__ + "static/selfreliance-f6e317ba792b4327af77afafb05c9f55.jpg";